<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="vin">
          <el-input
            v-model="queryForm.vin"
            @keyup.enter.native="query"
            placeholder="车架号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="deviceId">
          <el-input
            v-model="queryForm.deviceId"
            @keyup.enter.native="query"
            placeholder="设备ID"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="replaceName">
          <el-input
            v-model="queryForm.ecuSerialNum"
            @keyup.enter.native="query"
            placeholder="电控单元序列号"
          ></el-input>
        </el-form-item>
        <div style="display: inline-block;margin-bottom:20px">
          <el-button
            v-if="hasPerm('device:replace:list')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('device:replace:list')" @click="reset"
            >取消</el-button
          >
        </div>
      </div>
    </el-form>
    <div class="con">
      <p class="dialog-title">终端设备</p>
      <table border="1" class="infoTable">
        <tr>
          <th class="table-header">车架号</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.name }}</span>
            </template>
          </td>
          <th class="table-header">硬件版本号</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.leaderName }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">设备ID</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">软件版本</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">设备型号</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">lac</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">设备激活状态</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">cid</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">设备在线状态</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">net</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">电控单元序列号</th>
          <td class="stable-con" colspan="3">
            <template>
              <span>{{ deptInfoList.addr }}</span>
            </template>
          </td>
        </tr>
      </table>

      <p class="dialog-title">SIM卡信息</p>
      <table border="1" class="infoTable">
        <tr>
          <th class="table-header">运营商信息</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.name }}</span>
            </template>
          </td>
          <th class="table-header">SIM卡状态</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.leaderName }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">激活日期</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">电话号码</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">ICCID</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">通讯计划</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">资费计划</th>
          <td class="stable-con" colspan="3">
            <template>
              <span>{{ deptInfoList.addr }}</span>
            </template>
          </td>
        </tr>
      </table>

      <p class="dialog-title">车联网服务状态</p>
      <table border="1" class="infoTable">
        <tr>
          <th class="table-header">服务器地址</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.maintainNum }}</span>
            </template>
          </td>
          <th class="table-header">上线时间</th>
          <td class="table-con">
            <template>
              <span>{{ deptInfoList.phone }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="table-header">离线时间</th>
          <td class="stable-con" colspan="3">
            <template>
              <span>{{ deptInfoList.addr }}</span>
            </template>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        vin: "",
        deviceId: "",
        ecuSerialNum: "",
      },
      deptInfoList: {},
    }
  },
  methods: {
    query() {
      //this.getRecordList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      //this.getRecordList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  background: #fff;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
// 表格样式
table,
table tr th,
table tr td {
  border: 1px solid #dfdfdf;
}
table {
  margin: 20px 0;
}
.infoTable {
  border-collapse: collapse;
  line-height: 32px;
  font-size: 14px;
  color: #333;
}
.table-header {
  width: 150px;
  height: 34px;
  text-align: center;
  background-color: #ddeffd;
}
.table-con {
  width: 358px;
  height: 32px;
  text-align: left;
}
.infoTable span {
  padding-left: 12px;
}
.infoTable /deep/ .el-input__inner {
  height: 34px;
  padding-left: 12px;
}
</style>
